import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAIz1P0CIihghHg4DWNWisdi9mBkc1sLhs",
  authDomain: "adam-radar-b3598.firebaseapp.com",
  projectId: "adam-radar-b3598",
  storageBucket: "adam-radar-b3598.firebasestorage.app",
  messagingSenderId: "296052527589",
  appId: "1:296052527589:web:db2332b721073ab8769f0c",
  measurementId: "G-9G8B3Q2EYE",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Cloud Messaging
const messaging = getMessaging(app);

export { messaging };
